(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name core.controller:addikoMTokenSign
     *
     * @description
     *
     */
    angular
        .module('core')
        .directive('addikoSwitch', addikoSwitch);

    function addikoSwitch() {
        return {
            restrict: 'E',
            scope: {
                model: '='
            },
            templateUrl: 'core/components/switch/switch.tpl.html',
            replace: false,
            controllerAs: 'vm',
            controller: function ($scope) {
                
                $scope.toggle = function() {
                    $scope.model = !$scope.model;
                }
            }
        };
    }
}());